import * as ReactNative from 'react-native-web';
import PropTypes from 'prop-types';

ReactNative.Text.propTypes = { style: PropTypes.any };
ReactNative.View.propTypes = { style: PropTypes.any };
ReactNative.Image.propTypes = { style: PropTypes.any };
